<template>
  <div v-html="html" @click="goto"></div>
</template>

<script setup>
const props = defineProps(["html"]);
const goto = (e) => {
  const href = e.target.href;
  if (!href) return;
  if (e.target.tagName == "A" && href) {
    const url = new URL(href);

    if (window.location.hostname == url.hostname) {
      e.preventDefault();
      document.body.classList.remove("frzn");
      return navigateTo(url.pathname + url.search + url.hash);
    }
  }
  if (href.startsWith("tel:")) useMetrika("phone");
  else if (href.startsWith("email:")) useMetrika("email");

  /*
  if (e.target.tagName != "A" || !e.target.href) return;
  const href = e.target.href;
  const url = new URL(href);

  if (window.location.hostname == url.hostname) {
    document.body.classList.remove("frzn");
    return navigateTo(url.pathname + url.search + url.hash);
  }
  navigateTo(href, {
    external: true,
    open: {
      target:
        href.startsWith("tel:") || href.startsWith("email:")
          ? "_self"
          : "_blank",
    },
  });*/
};
</script>
